export const SET_BLOG_LIST_LOADING = 'SET_BLOG_LIST_LOADING';
export const SET_BLOG_LIST = 'SET_BLOG_LIST';
export const SET_BLOG_LIST_ERROR = 'SET_BLOG_LIST_ERROR';

export const SET_BLOG_ITEM_LOADING = 'SET_BLOG_ITEM_LOADING';
export const SET_BLOG_ITEM = 'SET_BLOG_ITEM';
export const SET_BLOG_ITEM_ERROR = 'SET_BLOG_ITEM_ERROR';
